// Shared by the Play & Pause Devices page, the mobile Dashboard sheet and the
// "Devices paused" bar: one event so a pause or resume anywhere updates the rest
// at once (other devices catch up on their next poll).
export const DEVICES_PAUSE_CHANGED = 'prvsk:devices-pause-changed';

export const announcePauseChange = () => window.dispatchEvent(new Event(DEVICES_PAUSE_CHANGED));

export function fmtRemaining(secs) {
  if (!secs || secs <= 0) return '';
  const d = Math.floor(secs / 86400);
  const h = Math.floor((secs % 86400) / 3600);
  const m = Math.floor((secs % 3600) / 60);
  if (d > 0) return `${d}d ${h}h left`;
  if (h > 0) return `${h}h ${m}m left`;
  return `${m}m left`;
}
